"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadinessCheckerAudioTest = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _ReadinessCheckerAudioTest = require("./ReadinessCheckerAudioTest.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _getEnvVar = require("@studio/environment/getEnvVar");
var _useCommonPageActionsApi = require("@studio/metrics/client/react/useCommonPageActionsApi");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ReadinessCheckerAudioTest = exports.ReadinessCheckerAudioTest = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$audioDeviceId = _ref.audioDeviceId,
    audioDeviceId = _ref$audioDeviceId === void 0 ? '' : _ref$audioDeviceId;
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    testAudioButtonClicked = _useCommonPageActions.testAudioButtonClicked;
  var audioStatuses = {
    STOPPED: 'STOPPED',
    PLAYING: 'PLAYING'
  };
  var iconMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, audioStatuses.STOPPED, _freeSolidSvgIcons.faPlay), audioStatuses.PLAYING, _freeSolidSvgIcons.faStop);
  var _useState = (0, _react.useState)(audioStatuses.STOPPED),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    audioStatus = _useState2[0],
    setAudioStatus = _useState2[1];
  var vidRef = (0, _react.useRef)(null);
  var handlePlayVideo = function handlePlayVideo() {
    vidRef.current.setSinkId(audioDeviceId);
    vidRef.current.play();
    testAudioButtonClicked();
    setAudioStatus(audioStatuses.PLAYING);
  };
  var handleStopVideo = function handleStopVideo() {
    vidRef.current.pause();
    vidRef.current.currentTime = 0;
    setAudioStatus(audioStatuses.STOPPED);
  };
  var buttonMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, audioStatuses.STOPPED, handlePlayVideo), audioStatuses.PLAYING, handleStopVideo);
  var handleStoppedVideo = function handleStoppedVideo() {
    setAudioStatus(audioStatuses.STOPPED);
  };
  (0, _react.useEffect)(function () {
    if (vidRef && vidRef.current) {
      vidRef.current.addEventListener('ended', handleStoppedVideo);
    }
    return function () {
      if (vidRef && vidRef.current) {
        vidRef.current.removeEventListener('ended', handleStoppedVideo);
      }
    };
  }, [vidRef]);
  var testAudioSound = (0, _getEnvVar.getEnvVar)('REACT_APP_STATIC_ASSETS_BASE_URL') + 'testAudioSound.mp4';
  var tooltipTextMap = (0, _defineProperty2["default"])({}, audioStatuses.STOPPED, 'Test audio to make sure you can hear others');
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyledAudioPlayerWrapper, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyleVideoWrapper, null, /*#__PURE__*/_react["default"].createElement("video", {
    ref: vidRef,
    src: testAudioSound,
    "aria-label": "Readiness checker sound test"
  }, "Your browser does not support the video file")), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.StyledButton, {
    title: tooltipTextMap[audioStatus],
    "data-dd-action-name": "Readiness Checker audio test initiated",
    "aria-label": "Click to listen to readiness checker sound test",
    color: "light",
    variant: "outlined",
    onClick: buttonMap[audioStatus],
    "data-testid": "playButton",
    disabled: disabled,
    id: "playButton",
    icon: iconMap[audioStatus]
  }), audioStatus === audioStatuses.STOPPED && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    "data-testid": "tooltip",
    placement: "top",
    target: "playButton"
  }, tooltipTextMap[audioStatus]));
});
ReadinessCheckerAudioTest.propTypes = {
  disabled: _propTypes["default"].bool,
  audioDeviceId: _propTypes["default"].string
};